export default __webpack_public_path__ + "static/media/template_business-man__0024_3---stanley-choii.5057bab9.png";